module.exports = __webpack_public_path__ + "static/media/scalpel-path.678211cf.svg";